<head>
    <link rel="stylesheet" href="reset-password.component.css">
  </head>
  <body>
    <div class="leftHalf">
      <img [src]="bgImage" style="width: 100%; height: 100vh;" alt="">
    </div>
  
    <div class="resetContainer">
      <div class="resetForm">
        <div class="formhead">
          <h2 style="text-align: center; font-size: 40px;">{{ title }}</h2>
          <p style="text-align: center;">
            {{
              tokenSent
                ? tokenVerified
                  ? "Enter your new password"
                  : "Enter the verification code"
                : "Enter your email to reset password"
            }}
          </p>
        </div>
  
        <div class="progress-steps">
          <div class="step" [class.active]="!tokenSent"></div>
          <div class="step" [class.active]="tokenSent && !tokenVerified"></div>
          <div class="step" [class.active]="tokenVerified"></div>
        </div>
        <div class="col s12" style="margin-bottom: 0px;">

          <!-- Step 1: Enter Email -->
          <form>
          <div class="row" *ngIf="!tokenSent">
            <div class="input-field col s12">
              <i class="material-icons prefix">email</i>
              <input
                type="email"
                class="validate"
                placeholder="Email"
                [(ngModel)]="resetData.email"
                name="email"
                required
                (input)="onEmailInput($event)"
              />
            </div>
            <button
              (click)="sendResetToken(resetData.email)"
              class="btn btn-login"
              style="display: block; margin: 0 auto; line-height: 0px; background: #E65F53;"
            >
              Send Reset Link
            </button>
          </div>
        
          <!-- Step 2: Enter Token -->
          
          <div class="" *ngIf="tokenSent && !tokenVerified">
            <div class="input-field col s12">
              <i class="material-icons prefix">confirmation_number</i>
              <input
                type="text"
                class="validate"
                placeholder="Enter Code"
                [(ngModel)]="resetData.strToken"
                name="token"
                required
              />
            </div>
          
            <!-- Button and arrow -->
            <div class="button-wrapper">
              <i class="material-icons back-icon" (click)="tokenSent = false">arrow_back</i>
              <button
                (click)="validateVerificationToken(resetData.email, resetData.strToken)"
                class="btn btn-login"
                style="display: block; margin: 0 auto; line-height: 0px; background: #E65F53;"
              >
                Verify Code
              </button>
            </div>
          </div>
          
        
          <!-- Step 3: Set New Password -->
          <div class="row" *ngIf="tokenVerified">
            <div class="input-field col s12">
              <i class="material-icons prefix">lock</i>
              <input
                type="password"
                name="Password"
                class="validate"
                placeholder="New Password"
                [(ngModel)]="resetData.strPassword"
                (ngModelChange)="resetErrorMessage()"
                #passwordInput
                required
              />
            </div>
        
            <div class="input-field col s12">
              <i class="material-icons prefix">lock</i>
              <input
                type="password"
                name="password"
                class="validate"
                placeholder="Confirm Password"
                (ngModelChange)="resetErrorMessage()"
                #confirmPasswordInput
                (input)="validatePassword(passwordInput.value, confirmPasswordInput.value)"
                required
              />
            </div>
        

            <button
              (click)="changePassword(resetData.email,resetData.strPassword)"
              class="btn btn-login"
              style="display: block; margin: 0 auto; line-height: 0px; background: #E65F53;"
              [disabled]="error_message !== ''"
            >
              Reset Password
            </button>
          </div>
        
          <div *ngIf="loading" class="overlay">
            <div class="spinner"></div>
          </div>

          <!-- Error Message -->
          <div class="row">
            <p class="error">{{ error_message }}</p>
          </div>
        </form>
        </div>
    
        <div class="signup" style="text-align: center; padding-top: 10%;">
          <a [routerLink]="'/login'">Back to Login</a>
        </div>
        